import { render, staticRenderFns } from "./poc-vs-radio.vue?vue&type=template&id=2ae01bb2&"
import script from "./poc-vs-radio.vue?vue&type=script&lang=js&"
export * from "./poc-vs-radio.vue?vue&type=script&lang=js&"
import style0 from "./poc-vs-radio.vue?vue&type=style&index=0&id=2ae01bb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports